/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type studioDashboardComponent_viewer$ref: FragmentReference;
declare export opaque type studioDashboardComponent_viewer$fragmentType: studioDashboardComponent_viewer$ref;
export type studioDashboardComponent_viewer = {|
  +insightComponentsData: ?{|
    +studioDashboard: ?{|
      +id: string,
      +currency: ?string,
      +minutesAllRemaining: ?number,
      +minutesAllForecast: ?number,
      +minutesAllTimeRegs: ?number,
      +minutesBillableRemaining: ?number,
      +minutesBillableForecast: ?number,
      +minutesBillableTimeRegs: ?number,
      +minutesNonBillableRemaining: ?number,
      +minutesNonBillableForecast: ?number,
      +minutesNonBillableTimeRegs: ?number,
      +costAllRemaining: ?number,
      +costAllForecast: ?number,
      +costAllTimeRegs: ?number,
      +costBillableRemaining: ?number,
      +costBillableForecast: ?number,
      +costBillableTimeRegs: ?number,
      +costNonBillableRemaining: ?number,
      +costNonBillableForecast: ?number,
      +costNonBillableTimeRegs: ?number,
      +priceAllRemaining: ?number,
      +priceAllForecast: ?number,
      +priceAllTimeRegs: ?number,
      +priceBillableRemaining: ?number,
      +priceBillableForecast: ?number,
      +priceBillableTimeRegs: ?number,
      +priceNonBillableRemaining: ?number,
      +priceNonBillableForecast: ?number,
      +priceNonBillableTimeRegs: ?number,
      +expensesCost: ?number,
      +expensesPrice: ?number,
    |}
  |},
  +$refType: studioDashboardComponent_viewer$ref,
|};
export type studioDashboardComponent_viewer$data = studioDashboardComponent_viewer;
export type studioDashboardComponent_viewer$key = {
  +$data?: studioDashboardComponent_viewer$data,
  +$fragmentRefs: studioDashboardComponent_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "componentId",
      "type": "ID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dateCriteria",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "studioDashboardComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "componentId",
              "variableName": "componentId"
            },
            {
              "kind": "Variable",
              "name": "dateCriteria",
              "variableName": "dateCriteria"
            }
          ],
          "concreteType": "StudioDashboard",
          "kind": "LinkedField",
          "name": "studioDashboard",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesAllRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesAllForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesAllTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesBillableRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesBillableForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesBillableTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesNonBillableRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesNonBillableForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "minutesNonBillableTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costAllRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costAllForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costAllTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costBillableRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costBillableForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costBillableTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costNonBillableRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costNonBillableForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "costNonBillableTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceAllRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceAllForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceAllTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceBillableRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceBillableForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceBillableTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceNonBillableRemaining",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceNonBillableForecast",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceNonBillableTimeRegs",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expensesCost",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "expensesPrice",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '0cc33d321c17e385e7396ec635d12433';

module.exports = node;
